/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const conflictListRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.import_conflict),
  getBaseQueryKey(Query_Keys.employees),
  getBaseQueryKey(Query_Keys.search_guests),
  getBaseQueryKey(Query_Keys.associated_guest_restaurants),
  getBaseQueryKey(Query_Keys.top_restaurants),
  getBaseQueryKey(Query_Keys.guest_activity_log),
);

export const conflictMutationKeyGroups = {
  merge: conflictListRefreshKeys,
  create: conflictListRefreshKeys,
  discard: conflictListRefreshKeys,
};
